import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getRq, postRq, getAuth, patchAuth, postAuth, deleteAuth } from '../Utils';


// Login/Logout
export function postLogin(successCallback, errorCallback, data) {
  postRq({
    "path": `login`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function postLogout(successCallback, errorCallback) {
  postAuth({
    "path": `logout`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


// Registration
export function postRegister(successCallback, errorCallback, data) {
  postAuth({
    "path": `register`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function getViewRegister(successCallback, errorCallback, qs={}) {
  getRq({
    "path": urlUtils.appendQueryString(`view/register`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


// Password
export function postResetPassword(successCallback, errorCallback, data) {
  postRq({
    "path": `reset-password`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function postChangePassword(successCallback, errorCallback, data) {
  postAuth({
    "path": `change-password`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function postSetNewPassword(successCallback, errorCallback, data, uidb64, token) {
  postRq({
    "path": `set-new-password/${uidb64}/${token}`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function postSetPasswordAddedUser(successCallback, errorCallback, data, key) {
  postRq({
    "path": `set-password-added-user/${key}`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function postSetupUser(successCallback, errorCallback, data) {
  postAuth({
    "path": `setup-user`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}


// Email
export function postChangeEmail(successCallback, errorCallback, data) {
  postAuth({
    "path": `change-email`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function getViewEmailShforms(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/email-shforms`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}



// User Management
function pathUsers(userId=null) {
  if (userId) {
      return `users/${userId}`;
  } else {
      return `users`;
  }
}

export function patchUsers(successCallback, errorCallback, data, userId) {
  patchAuth({
    "path": pathUsers(userId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteUsers(successCallback, errorCallback, userId) {
  deleteAuth({
    "path": pathUsers(userId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postOwnerAddUser(successCallback, errorCallback, data) {
  postAuth({
    "path": `users/owner-add`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function postOwnerEditUser(successCallback, errorCallback, data, userId) {
  postAuth({
    "path": `users/${userId}/owner-edit`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function postEditUserDetails(successCallback, errorCallback, data) {
  postAuth({
    "path": `users/edit-details`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function postResendUserRegisterVerification(successCallback, errorCallback, userId) {
  postAuth({
    "path": `users/${userId}/resend-register-verification`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postResendUserAddedVerification(successCallback, errorCallback, userId) {
  postAuth({
    "path": `users/${userId}/resend-added-verification`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


export function getViewManageUsers(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-users`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewManageUserMemberships(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-user-memberships`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewUserDetailsShforms(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/user-details-shforms`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


